/**
 * 표시 컴포넌트에서 alias 우선 표시명을 결정한다.
 *
 * 정책:
 * - alias가 trim 후 비어 있지 않으면 alias 원문 유지
 * - 그 외에는 raw name fallback
 *
 * worker/rawData 단계에서는 호출 금지 — name 필드는 식별/매칭용 raw 값으로 보존되어야 한다.
 * widget adapter/setup의 표시 series 구성 시 1회만 호출한다.
 */
export const getDisplayName = (name: string, alias?: string | null): string =>
  alias?.trim() ? alias : name;
